import { render } from "./error-message.vue?vue&type=template&id=a3daa5a8&ts=true"
import script from "./error-message.ts?vue&type=script&lang=ts&external"
export * from "./error-message.ts?vue&type=script&lang=ts&external"

import "./error-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__